import React from 'react';
import { Segmented, Button, Popconfirm } from 'antd';
import { LogoutOutlined, ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { logout } from './api';
import { PUBLIC_HTTPS_URL } from '../config';

const SettingsPanel = ({ user }) => {
  const [t, i18n] = useTranslation();
  const lang = i18n.language.slice(0, 2) === 'en' ? 'en' : 'tr';

  const setLang = (value) => {
    i18n.changeLanguage(value);
    localStorage.setItem('lang', value);
  };

  const publicUrl = `${PUBLIC_HTTPS_URL}/${user.username}`;

  return (
    <div className="dash-panel">
      <header className="dash-panel__head">
        <h1>{t('dash.nav.settings')}</h1>
      </header>

      <section className="dash-card dash-section">
        <div className="dash-setting">
          <div>
            <h2>{t('language')}</h2>
            <p className="dash-muted">{t('dash.languageHint')}</p>
          </div>
          {/* Names in their own language, so either can be found whatever is active */}
          <Segmented value={lang} onChange={setLang} options={[{ value: 'tr', label: 'Türkçe' }, { value: 'en', label: 'English' }]} />
        </div>
      </section>

      <section className="dash-card dash-section">
        <h2>{t('dash.account')}</h2>
        <dl className="dash-dl">
          <dt>{t('dash.username')}</dt>
          <dd>@{user.username}</dd>
          <dt>{t('dash.pageAddress')}</dt>
          <dd><a href={`/${user.username}`} target="_blank" rel="noopener noreferrer">{publicUrl.replace(/^https?:\/\//, '')} <ExportOutlined /></a></dd>
        </dl>
        <div className="dash-setting dash-setting--split">
          <div>
            <h2>{t('dash.session')}</h2>
            <p className="dash-muted">{t('dash.logoutHint')}</p>
          </div>
          <Popconfirm title={t('dash.logoutConfirm')} okText={t('dash.logout')} cancelText={t('dash.cancel')} onConfirm={logout} placement="topRight">
            <Button icon={<LogoutOutlined />}>{t('dash.logout')}</Button>
          </Popconfirm>
        </div>
      </section>
    </div>
  );
};

export default SettingsPanel;
